import { OverlayModule } from '@angular/cdk/overlay'
import { ChangeDetectionStrategy, Component, input, model, signal } from '@angular/core'
import { Clicks } from '@shared/directives'

@Component({
  selector: 'selector',
  imports: [OverlayModule, Clicks],
  templateUrl: './selector.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'min-w-36'
  }
})
export class Selector<T> {
  options = input.required<T[]>()
  optionLabel = input<string>()
  optionValue = input<string>()
  rotateIcon = input<boolean>(false)

  selectedOption = model.required<T>()
  isOpen = signal(false)

  select(option: T) {
    this.selectedOption.set(option)
    this.isOpen.set(false)
  }

  getValue(option: T): string {
    const optionValue = this.optionValue()

    if (!optionValue) return String(option)
    return String(option[optionValue as keyof T])
  }

  textToShow(option: T): string {
    const optionLabel = this.optionLabel()

    if (!optionLabel) return String(option)
    return String(option[optionLabel as keyof T])
  }
}
